export enum GroupMeetingType {
    bariGroupSession = 'bariGroupSession',
    bariMdo = 'bariMdo',
}
